import { useMutation } from "@tanstack/react-query";
import { useSetUserContext, useUserContext } from "../useUserContext";
import { updateUserQbSetup } from "../../_firebase/user";
import { QBBankAccount, QBTaxGroup } from "../../@types/quickbooks";

const useUpdateUserQbSetup = () => {
  const user = useUserContext();
  const setUserContext = useSetUserContext();

  const mutation = useMutation({
    mutationFn: ({
      qbTaxGroup,
      qbBankAccount,
    }: {
      qbTaxGroup: QBTaxGroup;
      qbBankAccount: QBBankAccount;
    }) => updateUserQbSetup(user.uid, qbTaxGroup, qbBankAccount),
    onSuccess: ({ qbTaxGroup, qbBankAccount, taxRate }) => {
      setUserContext({
        ...user,
        settings: { ...user.settings, qbTaxGroup, qbBankAccount, taxRate },
      });
    },
  });

  return mutation;
};

export default useUpdateUserQbSetup;
